module.exports = __webpack_public_path__ + "img/logo_norven_negativo_tagline.9715095c.png";